import React from 'react'
import { Container, Grid, useMediaQuery } from '@material-ui/core'
import { ConfigurationEmailRenovationPure } from '../../pures'

const ConfigurationEmailConfirmationView = (props) => {

  const longmatches = useMediaQuery('(max-width:1200px)')

  const globalContainerStyles = {
    display: 'inline-block',
    justifyContent: 'flex-start',
    maxWidth: '100%',
    marginRight: '105px',
    width: 'auto'
  }
  if (longmatches) {
    globalContainerStyles.marginRight = 0
  }
  const containerTableAndHeadersStyles = {
    marginTop: '20px',
    maxWidth: '100%'
  }

  return (
    <div>
      {/* { (props.loading) ? <SimpleLoading /> : */}
      <Container spacing={4} lg={12} md={12} style={globalContainerStyles} >

        {/* Table and Headers */}
        <Grid item xs={12} lg={12} md={12} sm={12} style={containerTableAndHeadersStyles} >
          <ConfigurationEmailRenovationPure
            {...props}
          />
        </Grid>

      </Container>
      {/* } */}
    </div>
  )
}

export { ConfigurationEmailConfirmationView as default }